import { FC, useCallback, useState } from 'react';
import { GoogleMap, CircleF, useJsApiLoader } from '@react-google-maps/api';

import { GOOGLE_MAPS_MAP_ID } from '@/utils/googleMaps';

type MapContentProps = {
  experienceLocation: {
    lat: number;
    lng: number;
  };
};

export const MapContent: FC<MapContentProps> = ({ experienceLocation }) => {
  const [map, setMap] = useState<google.maps.Map | null>(null);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY || '',
  });

  const onLoad = useCallback(function callback(map: google.maps.Map) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map: google.maps.Map) {
    setMap(null);
  }, []);

  return (
    <div className="relative w-full h-[60vh] min-h-[600px] overflow-hidden">
      <div className="w-full h-full absolute top-[0px] left-[0px] bg-[rgb(229, 227, 223)]">
        {isLoaded && (
          <GoogleMap
            mapContainerClassName="relative overflow-hidden w-full h-[60vh] min-h-[600px]"
            center={experienceLocation}
            zoom={13}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={{
              mapId: GOOGLE_MAPS_MAP_ID,
              fullscreenControl: false,
              zoomControlOptions: { position: 3.0 },
              tilt: 13,
              zoom: 13,
              minZoom: 13,
              isFractionalZoomEnabled: false,
              keyboardShortcuts: false,
              streetViewControl: false,
              mapTypeControl: false,
            }}>
            <CircleF
              center={experienceLocation}
              radius={1900}
              options={{
                strokeColor: 'steelblue',
                strokeOpacity: 0.5,
                strokeWeight: 0.3,
                fillColor: '#59b2d6',
                fillOpacity: 0.3,
              }}
            />
          </GoogleMap>
        )}
      </div>
    </div>
  );
};
